import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { MainNavSingleItemData } from '../../model/main-nav.model';

@Component({
  selector: 'sh-main-nav-single-item-external',
  templateUrl: './main-nav-single-item-external.component.html',
  styleUrl: './main-nav-single-item-external.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MainNavSingleItemExternalComponent {
  @Input() item: MainNavSingleItemData | undefined;
  @Output() closeMenu = new EventEmitter();

  onCloseMenu() {
    // for mobile menu - to close menu after nav item clicked
    this.closeMenu.emit();
  }
}
